import { ArrowDownRight, Download, Mail } from 'lucide-react';
import { profile } from '@/data/profile';
import { experience } from '@/data/experience';
import { AnchorButton } from '@/components/common/Button';
import { SocialLinks } from '@/components/common/SocialLinks';
import { Container } from '@/components/common/SectionHeading';
import styles from './Hero.module.css';

export function Hero() {
  const currentRole = experience[0]?.role ?? 'Software Engineer';

  return (
    <section id="home" className={`section ${styles.hero}`} aria-labelledby="hero-title">
      <div className={styles.backdrop} aria-hidden="true" />
      <Container className={styles.inner}>
        <div className={`reveal ${styles.copy}`}>
          <p className={styles.eyebrow}>
            {currentRole} · {profile.location}
          </p>
          <h1 id="hero-title" className={styles.title}>
            {profile.fullName}
          </h1>
          <p className={styles.subtitle}>{profile.title}</p>
          <p className={styles.intro}>{profile.heroIntro}</p>

          <div className={styles.actions}>
            <AnchorButton href="#projects">
              View My Work
              <ArrowDownRight size={18} aria-hidden="true" />
            </AnchorButton>
            <AnchorButton href={profile.resumePath} variant="secondary" download>
              <Download size={18} aria-hidden="true" />
              Download Resume
            </AnchorButton>
            <AnchorButton href="#contact" variant="ghost">
              <Mail size={18} aria-hidden="true" />
              Contact Me
            </AnchorButton>
          </div>

          <SocialLinks className={styles.social} />
        </div>

        <aside className={`reveal ${styles.panel}`} aria-label="Professional highlights">
          <p className={styles.panelLabel}>Focus</p>
          <ul className={styles.focusList}>
            {profile.focusAreas.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </aside>
      </Container>
    </section>
  );
}
